/*
 *  Document   : consultant_clients_edit.js
 *  Author     : Exapoint
 *
 */

// Import required modules


export default class ConsultantClientsEdit {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantClientsEdit"] = this;
        this.init();
    }

    init() {
        this.initDisableUserButtons();
    }

    initDisableUserButtons() {
        let $form = $('#toggle-disabled-user');

        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        $('.enable-user-button').on("click", (function (n) {
            n.preventDefault();
            e.fire({
                title: jsVars.confirmText,
                text: jsVars.confirmEnableText,
                icon: "warning",
                showCancelButton: true,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-outline-primary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $form.submit();
                }
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") && $modal.modal('hide') :
                    "cancel" === n.dismiss;
            }))
        }));

        $('.disable-user-button').on("click", (function (n) {
            n.preventDefault();
            e.fire({
                title: jsVars.confirmText,
                text: jsVars.confirmDisableText,
                icon: "warning",
                showCancelButton: true,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $form.submit();
                }
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") && $modal.modal('hide') :
                    "cancel" === n.dismiss;
            }))
        }));


        let $formReset = $('#reset-user');

        $('.reset-user-button').on("click", (function (n) {
            n.preventDefault();
            e.fire({
                title: jsVars.confirmText,
                text: jsVars.confirmResetText,
                icon: "warning",
                showCancelButton: true,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $formReset.submit();
                }
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") && window.parent.location.reload() :
                    "cancel" === n.dismiss;

            }))
        }));


    }
}
